import { lazy } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';

const Hub = lazy(() => import('./Hub'));
const Saneamento = lazy(() => import('./Saneamento'));
const SaneamentoOc = lazy(() => import('./SaneamentoOc'));
const SaneamentoEmBreve = lazy(() => import('./Saneamento/EmBreve'));

/** Link antigo (o módulo se chamava Suprimentos até 2026-11-05) cai na mesma tela da Controladoria. */
function RedirecionaDeSuprimentos() {
    const { pathname, search } = useLocation();
    return <Navigate to={pathname.replace(/^\/suprimentos/, '/controladoria') + search} replace />;
}

export const controladoriaRoutes = [
    { path: '/suprimentos/*', element: <RedirecionaDeSuprimentos /> },
    // Tela inicial em cards: cada card só aparece com a permissão da aba (controladoria.ctp / .oc / .prc).
    {
        path: '/controladoria',
        element: (
            <ProtectedRoute anyOf={['controladoria.ctp', 'controladoria.oc', 'controladoria.prc']}>
                <Hub />
            </ProtectedRoute>
        ),
    },
    { path: '/controladoria/saneamento', element: <Navigate to="/controladoria" replace /> },
    {
        path: '/controladoria/saneamento/ctp',
        element: (
            <ProtectedRoute permission="controladoria.ctp">
                <Saneamento />
            </ProtectedRoute>
        ),
    },
    {
        path: '/controladoria/saneamento/oc',
        element: (
            <ProtectedRoute permission="controladoria.oc">
                <SaneamentoOc />
            </ProtectedRoute>
        ),
    },
    {
        path: '/controladoria/saneamento/prc',
        element: (
            <ProtectedRoute permission="controladoria.prc">
                <SaneamentoEmBreve tipo="PRC" nome="PRC" />
            </ProtectedRoute>
        ),
    },
];
